import { Routes } from '@angular/router';
import { UserComponent } from './user.component';
import { AuthGuardService } from '../guards/auth-guard.service';
import { UserEditComponent } from './user-edit/user-edit.component';
import { UserCreateComponent } from './user-create/user-create.component';

export const usersRoutes: Routes = [
  {
    path: 'user',
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'create',
        component: UserCreateComponent
      },
      {
        path: ':userId/edit',
        component: UserEditComponent
      },
      {
        path: '',
        component: UserComponent
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/user/user.routes.ts